import React from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { TicketAccessGate, useTicketAccess } from "../_useTicketAccess";
import TicketDrawer from "../_components/TicketDrawer";
import { MyBreadcrumb } from "utils";
import "../_styles.css";

const VALID_TABS = ["details", "comments", "files"];

function TicketViewContent() {
  const { id } = useParams();
  const location = useLocation();
  const history = useHistory();
  const { canManage } = useTicketAccess();
  const tabParam = new URLSearchParams(location.search).get("tab");
  const defaultTab = VALID_TABS.includes(tabParam) ? tabParam : "comments";

  return (
    <div className="ticket-system ticket-view-page">
      <MyBreadcrumb
        items={[
          { label: "Home", path: "/" },
          { label: "Tickets", path: "/tickets/dashboard" },
          { label: "View Ticket", path: "" },
        ]}
      />
      <TicketDrawer
        ticketId={id}
        open
        embedded
        defaultTab={defaultTab}
        canManage={canManage}
        onClose={() => history.push("/tickets/all")}
      />
    </div>
  );
}

export default function TicketView() {
  return (
    <TicketAccessGate>
      <TicketViewContent />
    </TicketAccessGate>
  );
}
